import { Typography } from '@chegg-ui/typography'
import {
  SYNONYM_ERROR_BODY,
  SYNONYM_ERROR_BUTTON_TEXT,
  SYNONYM_ERROR_HEADING,
} from '@chegg-wt/core-wa/state/constants'
import { useDispatch } from 'react-redux'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { SynonymErrorButton, SynonymErrorContainer } from './styled'

export const SynonymErrorState = ({ handleTryAgain }) => {
  const dispatch = useDispatch()

  const handleRetryError = () => {
    dispatch(
      userClick({
        origin: origins.proofReaderRetryErrorClick,
        value: 'synonym',
      })
    )
    handleTryAgain()
  }
  return (
    <SynonymErrorContainer>
      <Typography variant="body1" variantType="bold">
        {SYNONYM_ERROR_HEADING}
      </Typography>
      <Typography variant="body2" variantType="normal">
        {SYNONYM_ERROR_BODY}
        <SynonymErrorButton onClick={handleRetryError} data-test="wa-try-again">
          {SYNONYM_ERROR_BUTTON_TEXT}
        </SynonymErrorButton>
      </Typography>
    </SynonymErrorContainer>
  )
}
